const sortTopicsByName = <T extends { name: string }>(topics: T[]) =>
  topics.toSorted((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }),
  );

export default sortTopicsByName;
